<template>
  <div class="page-container">
    <section class="mt-4 mb-10">
      <h1 v-if="me" class="font-size--24 mt-10">펀다에이아이BNPL 결제</h1>
      <p class="description font-size--16 mt-4">
        서비스 결제액만큼 정해진 한도를 바로 받아서<br />
        필요한 서비스를 현금 없이 바로 이용하세요.
      </p>
      <p class="description font-size--14 mt-2">
        '대금지급위임계약'을 통해 대출액은 서비스 제공업체에 바로 결제됩니다.
      </p>
    </section>

    <section class="service-list">
      <h2 class="font-size--18 mb-4">결제 가능 서비스</h2>
      <div class="service-item" @click="goToBNPL">
        <div class="service-info">
          <h3 class="font-size--16">클린피아 초음파 식기세척기</h3>
          <p class="font-size--14 color--nice-grey">520만원</p>
        </div>
        <v-icon>mdi-chevron-right</v-icon>
      </div>
      <div class="service-item" @click="goToJangsa3">
        <div class="service-info">
          <h3 class="font-size--16">AI 장사비서 3개월 집중관리</h3>
          <p class="font-size--14 color--nice-grey">하루 약 15,900원(부가세 별도)</p>
        </div>
        <v-icon>mdi-chevron-right</v-icon>
      </div>
      <div v-if="showInsurance" class="service-item" @click="goToInsur">
        <div class="service-info">
          <h3 class="font-size--16">펀다에이아이 집금 서비스(Beta)</h3>
          <p class="font-size--14 color--nice-grey">BETA 서비스 중으로 문의 주시면 상담사가 연락 드립니다.</p>
        </div>
        <v-icon>mdi-chevron-right</v-icon>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {}
  },
  computed: {
    ...mapState('auth', ['me']),
    showInsurance() {
      // Always display the insurance service menu
      return true
    },
  },
  async created() {
    _meta({
      titles: ['펀다에이아이BNPL 결제'],
    })
  },
  methods: {
    async goToBNPL() {
      await this.$swal.basic.alert({
        text: 'BNPL 결제를 준비 중입니다. 화면 우측 하단 채팅 상담으로 문의해 주세요',
      })
    },
    async goToJangsa3() {
      await this.$router.push('/loan/funda-bnpl-jangsa3')
    },
    async goToInsur() {
      await this.$router.push('/loan/funda-bnpl-insur')
    },
  },
}
</script>

<style lang="scss" scoped>
.description {
  color: #666666;
  line-height: 1.5;
  text-align: left;
  margin-bottom: 24px;
  padding: 0 0px;
}

.service-list {
  padding: 0 16px;
}

.service-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background-color: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 12px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #e9ecef;
  }

  .service-info {
    h3 {
      margin: 0;
      font-weight: 500;
    }
    p {
      margin: 4px 0 0 0;
    }
  }
}
</style>
